/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Harvest_QuantityInputs */

const vi_care_log_harvest_quantity = /** @type {(inputs: Care_Log_Harvest_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chè tươi thu được`)
};

/**

* @param {Care_Log_Harvest_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_harvest_quantity = /** @type {((inputs?: Care_Log_Harvest_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Harvest_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_harvest_quantity(inputs)
});